import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';

import { environment } from 'src/environments/environments';
import LocalStorageUtil from '../utils/local-storage.util';
import { LocalStorageKeys } from '../utils/local-storage-keys.enum';
import CryptoUtil from '../utils/crypto.util';

export abstract class BaseService {
  protected readonly baseUrl = environment.apiUrl;

  constructor(protected readonly http: HttpClient) {}

  protected anonymousHeader() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
  }

  protected authorizedHeader() {
    const user = LocalStorageUtil.get(LocalStorageKeys.user);
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user?.token}`,
      }),
    };
  }

  protected multiPartFormDataHeader() {
    const user = LocalStorageUtil.get(LocalStorageKeys.user);
    return {
      headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${user?.token}`,
      }),
    };
  }

  protected authorizedHeaderMulti() {
    const user = LocalStorageUtil.get(LocalStorageKeys.user);
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${user?.token}`,
      }),
    };
  }

  protected extractData(response: any) {
    return response.data || {};
  }

  protected resp(response: any) {
    return response || {};
  }

  protected serviceError(response: Response | any) {
    let customError: string[] = [];
    let customResponse = new Error();

    if (response instanceof HttpErrorResponse) {
      if (response.statusText === 'Unknown Error') {
        customError.push('Unknown Error');
        response.error.errors = customError;
      }
    }

    if (response.status === 500) {
      customError.push('Error processing request');
      customResponse.error.errors = customError;
      return throwError(() => customResponse);
    }

    return throwError(() => response);
  }

  protected extractCryptoData(response: any) {
    const decryptedData = CryptoUtil.decrypt(environment.encrypt_key, response.data.payload);
    return JSON.parse(decryptedData);
  }

  protected encrypt(request: any) {
    const encryptedData = CryptoUtil.encrypt(environment.encrypt_key, JSON.stringify(request));
    return { payload: encryptedData };
  }
}

class Error {
  error: ErrorResponse = new ErrorResponse();
}

class ErrorResponse {
  errors: string[] = [];
}